<template lang="pug">
  div
    section.content-header
      h1 {{pageTitle}}

      ol.breadcrumb
        li
          router-link(:to="{name: 'admin'}")
            i.fa.fa-cog
            | システム管理
        li
          router-link(:to="{name: 'exlocation'}") 交換場所管理
        li.active {{pageTitle}}

    section.content
      //- メッセージ
      app-messages(:errorMessages="errors", :successMessages="successes")

      form(ref="form", @submit.prevent="postData", novalidate)
        mixin btnbar
          .bcard-btnbar(class!=attributes.class)
            button.btn.btn-primary(type="submit") {{actionName}}
            |
            |
            router-link.btn.btn-default(:to="{name: 'exlocation'}") キャンセル
            template(v-if="this.id")
              | &nbsp;
              .btn-separator
              | &nbsp;
              button.btn.btn-danger(type="button" @click="modalState = true") 削除

        +btnbar

        .box.box-widget

          .box-body
            .form-group
              label.control-label(for="bcard-exlocation-edit-name") 交換場所名
                span.bcard-required (*)
              input#bcard-exlocation-edit-name.form-control(type="text" v-model="item.name", :maxlength="maxlengths.name" required)

            p.bcard-required ※ (*)は必須項目です。

        +btnbar.-bottom

    //------------------------------------------------------------
    //- modals
    //------------------------------------------------------------
    app-modal(v-model="modalState" type="danger")
      template(slot="title") 交換場所情報の削除
      h4 交換場所情報を削除します。よろしいですか？
      template(slot="footer" slot-scope="{close}")
        button.btn.btn-danger(@click="delExlocation") 削除
        button.btn.btn-default(@click.prevent="close") キャンセル
</template>

<script>
import AppModal from '@/components/templates/AppModal'
import AppMessages from '@/components/molecules/AppMessages'
import mixinForm from '@/mixins/form'
import RepositoryFactory from '@/repositories/RepositoryFactory'

const ExlocationRepository = RepositoryFactory.get('exlocation')

export default {
  name: 'ExlocationEdit',
  components: { AppModal, AppMessages },
  mixins: [ mixinForm ],
  props: {
    id: {
      type: [String, Number],
      required: false,
      default: 0
    },
    item: {
      type: Object,
      required: false,
      default: function () {
        return {
          name: ''
        }
      }
    }
  },
  data: function () {
    return {
      pageTitle: this.id ? '交換場所情報の変更' : '交換場所情報の作成',
      actionName: this.id ? '変更' : '作成',
      modalState: false,
      maxlengths: {}
    }
  },
  created: function () {
    this.maxlengths = this.loadMaxlengths('Exlocations')
    // 変更時の初期データ
    if (this.id) {
      // API実行
      const vm = this
      ExlocationRepository.get(this.id)
        .then(function (response) {
          const exlocation = vm.getApiData(response).data
          vm.item.name = exlocation.name
        })
        .catch(function (error) {
          vm.setErrorMessage(error)
        })
    }
  },
  methods: {
    delExlocation: function () {
      const vm = this

      // 削除API実行
      ExlocationRepository.delete(this.id)

        // 成功時処理
        .then(function (response) {
          // 一覧画面を表示
          if (vm.isApiSuccess(response)) {
            vm.$router.push({name: 'exlocation'})
          }
        })

        // エラー時処理
        .catch(function (error) {
          vm.errors.push(vm.setErrorMessage(error))
        })
    },
    postData: function () {
      if (!this.checkFormValidity()) return

      const vm = this
      const params = {}
      let repos

      // 登録内容
      params.name = this.item.name

      // 更新オプション
      if (this.id) {
        repos = ExlocationRepository.put(this.id, params)
      // 作成オプション
      }
      else {
        repos = ExlocationRepository.post(params)
      }

      // API実行
      repos
        // 成功時処理
        .then(function (response) {
          // 一覧画面を表示
          if (vm.isApiSuccess(response)) {
            vm.$router.push({name: 'exlocation'})
          }
        })
        // システムエラー
        .catch(function (error) {
          vm.setErrorMessage(error)
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/admin/exlocation/Edit.vue